
export default class Adapter
{

}
